"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsUserPasswordValid = void 0;
function IsUserPasswordValid(password, id) {
    // NOTE: 영문, 숫자, 특수문자(키보드에서 사용할 수 있는 모든 특수문자) 포함 8자리 이상, id 있는 경우 password, id 값 불일치
    if (password.match(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[\\!@#$%^&*()_+,./?<>`~{}[\]=;:"'|-])[\\A-Za-z\d!@#$%^&*()_+,./?<>`~{}[\]=;:"'|-]{8,1024}$/) &&
        (!id || password !== id)) {
        return true;
    }
    else {
        return false;
    }
}
exports.IsUserPasswordValid = IsUserPasswordValid;
//# sourceMappingURL=validator.js.map